export default __webpack_public_path__ + "static/media/pencil.d63ed9ae.svg";